import axios from 'axios'
import store from '../src/store'
import properties from "../src/properties";
import utils from "../src/utilities";

export const BASE_URL = process.env.VUE_APP_API_ENDPOINT;

let requests = {

    login(username, password, loginCallBack, failedLoginCallBack) {

        var querystring = require('querystring');

        axios.post(BASE_URL + 'rest/user/login', querystring.stringify({
                username: username,
                password: password
            }),
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            })
            .then((response) => {
                loginCallBack(response.data);
            })
            .catch((error) => {
                store.commit('setLoadingModal', false);
                failedLoginCallBack(error.response.data);
            })
    },

    get(path, getCallBack) {

        axios.get(BASE_URL + path,
            {headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('sup_token')
                }})
            .then((response =>{
                getCallBack(response.data)
            }))
            .catch((error => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            }))
    },

    post(path, data,  postCallBack) {

        axios.post(BASE_URL + path,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('sup_token')
                }
            })
            .then((response =>{
                postCallBack(response.data)
            }))
            .catch((error => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            }))
    },

    postForFiles(path, data,  postCallBack) {

        axios.post(BASE_URL + path,
            data,
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('sup_token')
                }
            })
            .then((response =>{
                postCallBack(response)
            }))
            .catch((error => {
                var storeObj = {
                    title: 'Σφάλμα!',
                    text: 'Κάτι πήγε στραβά κατά τη δημιουργία αναφοράς.',
                    color: 'indianRed',
                    class: 'white--text indianRed text-center justify-center'
                };
                if (error.response.status==405)
                    storeObj.text = 'Για να κατέβει η αναφορά θα πρέπει να έχει προηγηθεί είτε \"Προσωρινή αποθήκευση\" είτε \"Οριστική υποβολή\".';
                store.commit('setErrorPopup', true);
                store.commit('setErrorPopupProps', storeObj);
                store.commit('setLoadingModal', false);
            }))
    },


    put(path, data ,  putCallBack) {

        axios.put(BASE_URL + path, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('sup_token')
                }
            }
        )
            .then((response =>{
                putCallBack(response.data)
            }))
            .catch((error => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            }))
    },

    delete(path, requestObj, deleteCallBack){

        axios.delete( BASE_URL + path, {
            data: requestObj,
            headers: {
                'Content-Type': 'application/json',
                'Authentication': utils.getLocalStorage('sup_token')
            }})
            .then((response) => {
                deleteCallBack(response.data)
            })
            .catch((error =>{
                store.commit('setLoadingModal', false);
                properties.getErrorMessage(error.response.data);
            }))
    },
    
    
    getReports(path) {
        
        axios.get(BASE_URL + path,
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('sup_token')
                }
            })
            .then((response => {
                utils.downLoadXLSX(response);
                store.commit('setLoadingModal', false);
            }))
            .catch((error => {
                // custom error parsing here because of the responseType: 'blob' it cannot receive json so we sent it as header from the back end
                properties.getErrorMessage(decodeURIComponent(error.response.headers['errormessage']).replaceAll('+', " "));
                store.commit('setLoadingModal', false);
            }))
    },
    
    getStatementFilesReport(path) {
        
        axios.get(BASE_URL + path,
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('sup_token')
                }
            })
            .then((response => {
                utils.downloadFile(response);
                store.commit('setLoadingModal', false);
            }))
            .catch((error => {
                var storeObj = {
                    title: 'Σφάλμα!',
                    text: 'Κάτι πήγε στραβά κατά τη δημιουργία του αρχείου.',
                    color: 'indianRed',
                    class: 'white--text indianRed text-center justify-center'
                };
                
                store.commit('setErrorPopup', true);
                store.commit('setErrorPopupProps', storeObj);
                store.commit('setLoadingModal', false);
            }))
    },

    getWronglyDeliveredReport(path) {

        axios.get(BASE_URL + path,
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('sup_token')
                }
            })
            .then((response => {
                utils.downloadFile(response);
                store.commit('setLoadingModal', false);
            }))
            .catch((error => {
                var storeObj = {
                    title: 'Σφάλμα!',
                    text: 'Κάτι πήγε στραβά κατά τη δημιουργία του αρχείου.',
                    color: 'indianRed',
                    class: 'white--text indianRed text-center justify-center'
                };

                store.commit('setErrorPopup', true);
                store.commit('setErrorPopupProps', storeObj);
                store.commit('setLoadingModal', false);
            }))
    },
    
    
    setStatementBookExchangable(requestsStatementId, statementBookId, value, errorCallBack) {
        let requestObj = {
            id: statementBookId,
            exchangable: value,
        };
        
        axios.put(BASE_URL + 'rest/helpdesk/students/set-exchangable', requestObj, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('sup_token')
                }
            }
        )
            .then((response => {
                store.commit('setLoadingModal', false);
            }))
            .catch((error => {
                if (error) {
                    errorCallBack(requestsStatementId, statementBookId, value, error.response ? error.response.data : '');
                } else {
                    errorCallBack(requestsStatementId, statementBookId, value, '');
                }
                
            }))
    },

    cancelExchange( requestStatementId, statementBookId,  successCallBack) {

        axios.put(BASE_URL + 'rest/helpdesk/students/cancel-exchange', statementBookId, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('sup_token')
                }
            }
        )
        .then((response =>{
            successCallBack(requestStatementId,statementBookId);
        }))
        .catch((error => {
            store.commit('setLoadingModal', false);
            properties.getErrorMessage(error.response.data);
        }))
    },

    setStatementBookWronglyDelivered( requestsStatementId, statementBookId, value, errorCallBack) {
        let requestObj = {
            id: statementBookId,
            wronglyDelivered: value,
        };

        axios.put(BASE_URL + 'rest/helpdesk/students/set-wrongly-delivered', requestObj, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('sup_token')
                }
            }
        )
            .then((response =>{
                store.commit('setLoadingModal', false);
            }))
            .catch((error => {
                if(error){
                    errorCallBack(requestsStatementId, statementBookId, value, error.response?error.response.data:'');
                }else{
                    errorCallBack(requestsStatementId, statementBookId, value, '');
                }
                
            }))
    },

    putForMails(path, data ,  putCallBack) {

        axios.put(BASE_URL + path, data, {
                headers: {
                    'Content-Type': 'text/plain',
                    'Authentication': utils.getLocalStorage('sup_token')
                }
            }
        )
            .then((response =>{
                putCallBack(response.data)
            }))
            .catch((error => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            }))
    },

    uploadCsvWithJsonResponse(path, requestObj,putCallBack){
        const formData = new FormData();
        formData.append('file', requestObj);
        formData.append('name', encodeURIComponent(requestObj.name));

        axios.put(BASE_URL + path, formData, {
            headers: {
                'Content-Disposition': 'form-data; name=""',
                'File-name': 'file',
                'Content-Length': requestObj['size'],
                'Content-Type': 'multipart/form-data; ',
                'Authentication': utils.getLocalStorage('sup_token')
            }
        })
            .then((response =>{
                putCallBack(response.data)
            }))
            .catch((error => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            }))
    },

    extractCsv(path,requestObj){
        axios.put(BASE_URL + path, requestObj, {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json',
                'Authentication': utils.getLocalStorage('sup_token')
            }
        })
            .then((response =>{
                utils.downloadFile(response);
                store.commit('setLoadingModal', false);
            }))
            .catch((error => {
                var storeObj = {
                    title: 'Σφάλμα!',
                    text: 'Κάτι πήγε στραβά κατά τη δημιουργία του αρχείου.',
                    color: 'indianRed',
                    class: 'white--text indianRed text-center justify-center'
                };

                store.commit('setErrorPopup', true);
                store.commit('setErrorPopupProps', storeObj);
                store.commit('setLoadingModal', false);
            }))
    },
    

    logout(token, logoutCallBack) {

        axios.delete( BASE_URL + 'rest/user/logout',  {
            headers: {
                'Authentication': token
            }
        })
            .then((response) =>{
                logoutCallBack(response.data)
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },


    getYears(getYearsCallBack) {

        axios.get(BASE_URL + 'rest/app-info/academic-years', {
            headers: {
                'Content-Type': 'application/json',
                'Authentication': utils.getLocalStorage('sup_token')
            }
        })
            .then((response) => {
                getYearsCallBack(response.data)
            })
            .catch((error) => {
                store.commit('setLoadingModal', false);
            })
    },

    getCouriers(getCouriersCallBack) {
        axios.get(BASE_URL + 'rest/app-info/courier', {
            headers: {
                'Content-Type': 'application/json',
                'Authentication': utils.getLocalStorage('sup_token')
            }
        })
            .then((response) => {
                getCouriersCallBack(response.data)
            })
            .catch((error) => {
                store.commit('setLoadingModal', false);
            })
    },

    homePageInformation(homePageInformationCallBack) {

        axios.get(BASE_URL + 'rest/user', {
            headers: {
                'Content-Type': 'application/json',
                'Authentication': utils.getLocalStorage('sup_token')
            }
        })
            .then((response) => {
                homePageInformationCallBack(response.data);
            })
            .catch((error) => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            })
    },

    requestReport(data, createReportCallBack) {

        axios.put(BASE_URL + 'rest/reports/request', data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('sup_token')
                }
            }
        )
            .then((response =>{
                createReportCallBack(response)
            }))
            .catch((error => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            }))
    },

    downloadReport(data, requestReportCallBack) {

        axios.put(BASE_URL + 'rest/reports/download', data, {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Authentication': utils.getLocalStorage('sup_token')
                }
            }
        )
            .then((response =>{
                requestReportCallBack(response)
            }))
            .catch((error => {
                properties.getErrorMessage(error.response.data);
                store.commit('setLoadingModal', false);
            }))
    },


};

export default requests